import { gql } from '@apollo/client';

export const LOAD_METRIC_DEFINITION_BY_ID = gql`
query($id: ID!, $patientId: ID)
        {
            metric
            {
                metricDefinition
                {
                    metricDefinitionById(id: $id, patientId: $patientId)
                    {
                        id,
                        isGlobal,
                        title,
                        translations,
                        status,
                        organizationId,
                        defaultAggregationFunction,
                        components
                        {
                            __typename,
                            code
                            {
                                coding
                                {
                                    code,
                                    display,
                                    version,
                                    system
                                },
                                text
                            },
                            score,
                            scoreType,
                            ... on GqlNumericObservationComponent {
                                minValue,
                                maxValue,
                                value
                                {
                                    value,
                                    unit,
                                    system,
                                    code
                                },
                                scoreConfig
                                {
                                    scoreConditions
                                    {
                                        score,
                                        values
                                        {
                                            sign,
                                            value
                                        }
                                    }
                                }
                            }
                            ... on GqlScaleObservationComponent {
                                numberOfSteps,
                                value
                                {
                                    value,
                                    unit,
                                    system,
                                    code
                                },
                                scoreConfig
                                {
                                    scoreConditions
                                    {
                                        id,
                                        score,
                                        values
                                        {
                                            sign,
                                            value
                                        }
                                    }
                                }
                            }
                        },
                        code,
                        issued,
                        description,
                        category,
                        derivedFrom,
                    }
                }
            }
        }
`;